export default __webpack_public_path__ + "img/img03.52fc58e6.png";